module.exports = __webpack_public_path__ + "static/media/pattern-compose.63866e3f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/patterns/pattern-compose.svg
// module id = 1267
// module chunks = 37